import { put, take, takeEvery, select } from 'redux-saga/effects'
import { APIPath } from 'services/APIPath'
import { getType } from 'typesafe-actions'
import * as actions from './actions'
import { createDefect, updateDefect, setDefect } from './api'
import { DefectTypeReq, SetDefectReq } from './types'

import { uploadFile } from '../../uploadfile/func'
import { getUserProfile } from 'features/sensitive/sensitive.selector'

function* uploadFileList(
  userEmail: string,
  token: string,
  pin: any,
  username: string
) {
  const { ImageLocation, ImageBefore, ImageAfter } = pin

  if (ImageLocation && ImageLocation.file) {
    pin.ImageLocation = yield uploadFile(
      userEmail,
      token,
      username,
      ImageLocation
    )
  }

  if (ImageBefore && ImageBefore.file) {
    pin.ImageBefore = yield uploadFile(userEmail, token, username, ImageBefore)
  }

  if (ImageAfter && ImageAfter.file) {
    pin.ImageAfter = yield uploadFile(userEmail, token, username, ImageAfter)
  }

  return pin
}

function* sendDefectReq(action: any) {
  const {
    ProjectCode,
    UserEmail,
    Token,
    RequestID,
    Report,
    Defect,
  } = action.payload
  try {
    const { CheckNumber } = Report
    const pin: DefectTypeReq = {
      ProjectCode,
      UserEmail,

      RequestID,
      CheckNumber: Defect.CheckNumber === 0 ? CheckNumber : Defect.CheckNumber,

      PinID: Defect.PinID,
      PinNumber: Defect.PinNumber,

      JobTypeID: Defect.JobTypeID,
      SubJobTypeID: Defect.SubJobTypeID,
      DetailID: Defect.DetailID,
      LocationID: Defect.LocationID,

      PinStatus: Defect.PinStatus,
      Remark: Defect.Remark,

      ImageLocation: Defect.ImageLocation,
      ImageBefore: Defect.ImageBefore,
      ImageAfter: Defect.ImageAfter,

      VerifyStatus: 'None',
      VerifyRemark: '',
      HowToFix: '',
    }

    const profile = yield select(getUserProfile)
    const { FirstName = '', LastName = '' } = profile
    const username = `${FirstName} ${LastName} (${Report.State})`

    const newPin = yield uploadFileList(UserEmail, Token, pin, username)
    if (Defect.PinID === 0) {
      newPin.PinNumber = Report.DefectList.length + 1

      yield put(createDefect(Token, newPin))
    } else {
      yield put(updateDefect(Token, newPin))
    }
  } catch (e) {
    console.log('e', e.message)
  }
}

function* verifyDefectReq(action: any) {
  const {
    ProjectCode,
    UserEmail,
    Token,
    RequestID,
    Report,
    Defect,
  } = action.payload
  try {
    const { CheckNumber } = Report
    const pin: SetDefectReq = {
      ProjectCode,
      UserEmail,
      RequestID,

      PinID: Defect.PinID,
      ImageAfter: Defect.ImageAfter,
      HowToFix: Defect.HowToFix,
    }

    const profile = yield select(getUserProfile)
    const { FirstName = '', LastName = '' } = profile
    const username = `${FirstName} ${LastName} (${Report.State})`

    const newPin = yield uploadFileList(UserEmail, Token, pin, username)
    yield put(setDefect(Token, newPin))
  } catch (e) {
    console.log('e', e.message)
  }
}

function* allSaga() {
  yield takeEvery(getType(actions.submitDefectReq), sendDefectReq)
  yield takeEvery(getType(actions.setHowToFixReq), verifyDefectReq)
}

export default allSaga
